import React, { useEffect, useRef, useState } from 'react'
import Header from './Header'
import axios from 'axios'
import { API } from './constant'

import { MdClose } from "react-icons/md";

// images start 
import Lexile_rubric from "../assets/Lexile_rubric.png"


// material ui components start 
// import * as React from 'react';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';



const View = () => {
  const [updateTable, setupdateTable] = useState(false)

  const [editparagraph_name, seteditparagraph_name] = useState("")
  const [editlexile_score, seteditlexile_score] = useState("")
  const [editapprox_word_count, seteditapprox_word_count] = useState("")
  const [editstudent_age, seteditstudent_age] = useState([])
  const [editstudent_grade, seteditstudent_grade] = useState([])
  const [editparagraphType, seteditparagraphType] = useState("")
  const [editparagraph_details, seteditparagraph_details] = useState("")
  const [selectedParagraphId, setselectedParagraphId] = useState('')
  const [EditParagraphModal, setsetEditParagraphModal] = useState(false)

  const [paragraphName, setparagraphName] = useState([])
  const [showRubric, setShowRubric] = useState(false)



  const [TotalparagraphName, setTotalparagraphName] = useState([])

  const HandleEdit = async (id) => {
    setselectedParagraphId(id)
    setsetEditParagraphModal(true)

    await axios.get(`${API}/add-paragraph/${id}`)
      .then((res) => {
        console.log(res.data.data)
        seteditparagraph_name(res.data.data.paragraph_name)
        seteditlexile_score(res.data.data.lexile_score)
        seteditapprox_word_count(res.data.data.approx_word_count)
        seteditstudent_age(res.data.data.student_age)
        seteditstudent_grade(res.data.data.student_grade)
        seteditparagraphType(res.data.data.paragraphType)
        seteditparagraph_details(res.data.data.paragraph_details)

      })
      .catch((err) => {
        console.log(err)
      })
  }



  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    seteditstudent_age(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    );
  };
  const handleChangeGrade = (event) => {
    const {
      target: { value },
    } = event;
    seteditstudent_grade(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    );
  };




  const handleEditParagraph = async (id) => {
    const data = {
      paragraph_name: editparagraph_name,
      lexile_score: editlexile_score,
      approx_word_count: editapprox_word_count,
      student_age: editstudent_age,
      student_grade: editstudent_grade,
      paragraphType: editparagraphType,
      paragraph_details: editparagraph_details
    }
    await axios.put(`${API}/add-paragraph/${id}`, data, {
      headers: {
        "Content-Type": "application/json",
        "token": localStorage.getItem("token")
      }
    })
      .then((res) => {
        // console.log(res)
        alert(res.data.message)
        setupdateTable(!updateTable)
        setsetEditParagraphModal(false)
        clearFields()

      })
      .catch((error) => {
        console.log(error)
      })
  }

  const clearFields = () => {
    seteditparagraphType("")
  }

  // const handleEditParagraph = async (id) => {
  //   const data = {
  //     paragraph_name: editparagraph_name,
  //     lexile_score: editlexile_score,
  //     approx_word_count: editapprox_word_count,
  //     student_age: editstudent_age,
  //     student_grade: editstudent_grade,
  //     paragraph_details: editparagraph_details,
  //   };

  //   try {
  //     // Update the paragraph
  //     const res = await axios.put(
  //       `${API}/add-paragraph/${id}`,
  //       data,
  //       {
  //         headers: {
  //           'Content-Type': 'application/json',
  //           token: localStorage.getItem('token'),
  //         },
  //       }
  //     );

  //     // Log the update event
  //     await axios.post(
  //       `${API}/logs`,
  //       {
  //         action: 'update',
  //         resource: 'paragraph',
  //         resourceId: id,
  //         details: { paragraph_name: data.paragraph_name },
  //       },
  //       {
  //         headers: {
  //           'Content-Type': 'application/json',
  //           token: localStorage.getItem('token'),
  //         },
  //       }
  //     );

  //     // Update state and UI
  //     alert(res.data.message);
  //     setupdateTable(!updateTable);
  //     setsetEditParagraphModal(false);
  //   } catch (error) {
  //     console.error('Error updating paragraph or logging:', error);
  //     alert('Failed to update paragraph');
  //   }
  // };



  useEffect(() => {
    axios.get(`${API}/add-paragraph/`, {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${localStorage.getItem("token")}`
      }
    })
      .then((res) => {
        // console.log(res.data.data)
        setparagraphName(res.data.data)
        const total = res.data.data.length
        setTotalparagraphName(total)
      })
      .catch((err) => {
        console.log(err)
      })
  }, [updateTable])




  //============= ============find user role and give permission start ============================
  const [loggedinRole, setLoggedinRole] = useState("")
  useEffect(() => {
    axios.get(`${API}/login/logged-in-user`, {
      headers: {
        "Content-Type": "application/json",
        "token": localStorage.getItem("token")
      }
    })
      .then((res) => {
        setLoggedinRole(res.data.data.role)
      })
      .catch((err) => {
        // console.log(err);
        if (err.response) {
          // Handle invalid token
          if (err.response.status === 401) {
            localStorage.removeItem("token");
            // history.push('/');
            window.location.href = "/"
          }
          // Handle token expiration
          else if (err.response.status === 302) {
            window.location.href = "/"

          }
        }
      });
  }, [])

  //============= ============find user role and give permission end ============================





  // =======================edit paragraph details start ===============================


  // =======================edit paragraph details end ===============================




  const [fields, setFields] = useState([{ sentence: '', wordCount: 0, cumulativeWordCount: 0 }]);

  const handleInputChange = (index, event) => {
    const { value } = event.target;
    const updatedFields = [...fields];

    // Update the current field
    updatedFields[index] = {
      sentence: value,
      wordCount: value.trim().split(/\s+/).length,
      cumulativeWordCount: index === 0 ? value.trim().split(/\s+/).length : updatedFields[index - 1].cumulativeWordCount + value.trim().split(/\s+/).length
    };

    // Update subsequent fields' cumulative word count
    for (let i = index + 1; i < updatedFields.length; i++) {
      updatedFields[i] = {
        ...updatedFields[i],
        cumulativeWordCount: updatedFields[i - 1].cumulativeWordCount + updatedFields[i].wordCount
      };
    }

    setFields(updatedFields);
  };


  const handleAddField = () => {
    setFields([...fields, { sentence: '', wordCount: 0, cumulativeWordCount: fields.length > 0 ? fields[fields.length - 1].cumulativeWordCount : 0 }]);
  };

  const handleRemoveField = (index) => {
    const updatedFields = [...fields];
    updatedFields.splice(index, 1);
    setFields(updatedFields);
  };


  // ====================================get class data start ================================================

  // --------------get all class data start ----------
  const [allClassDATA, setallClassDATA] = useState([])
  useEffect(() => {
    axios.get(`${API}/create-class`)
      .then((res) => {
        // console.log(res)
        setallClassDATA(res.data.data)
      })
      .catch((err) => {
        console.log(err)
      })
  }, [updateTable])
  // ------------get all class data end------------
  // ====================================get class data end ================================================

  // =======================show student age in dropdown menu start =======================================

  //------- get all student age start -----------
  const [getAllStudetnAge, setgetAllStudetnAge] = useState([])
  // console.log(getAllStudetnAge)
  // console.log(getAllStudetnAge)
  useEffect(() => {
    axios.get(`${API}/student-age`)
      .then((res) => {
        // console.log(res.data.data)
        setgetAllStudetnAge(res.data.data)

      }).catch((err) => {
        console.log(err)
      })
  }, [])
  //------- get all student age end -----------

  // =======================show student age in dropdown menu end =======================================


  //--------------------- delete paragraph start ------------------------------
  const [deleteParagraph, setdeleteParagraph] = useState(false)
  const [deleteParagraphid, setdeleteParagraphid] = useState(false)
  const [deleteParagraphlogid, setdeleteParagraphlogid] = useState("")

  const HandleDeletePopUp = (id) => {
    setdeleteParagraph(true)
    setdeleteParagraphid(id)
  }

  const handleDeleteParagraph = (id) => {
    axios.delete(`${API}/add-paragraph/${id}`, {
      headers: {
        "Content-Type": "application/json",
        "token": localStorage.getItem("token")
      }
    })
      .then((res) => {
        console.log(res)
        // alert(res.data.message)

        // logs event start 
        // axios.post(`${API}/logs`, {
        //   action: 'delete',
        //   resource: 'paragraph',
        //   resourceId: id,
        //   // details: { paragraph_name: paragraph.paragraph_name },
        // })
        // logs event end
        setdeleteParagraph(false)
        setupdateTable(!updateTable)
        setdeleteParagraphlogid(id)
      })
      .catch((err) => {
        console.log(err)
      })

  }
  //--------------------- delete paragraph end ------------------------------

  //============================ print functionality start ====================================
  // --------print functionality start -------------
  const printRef = useRef();
  const handlePrint = (index) => {
    const printContents = document.getElementById(`printable-${index}`).innerHTML;
    const printWindow = window.open('', '', 'height=600,width=800');
    printWindow.document.write('<html><head><title>Lexile Paragraph</title>');
    printWindow.document.write('<style>@media print { body * { visibility: hidden; } .printable, .printable * { visibility: visible; } .printable { position: absolute; left: 0; top: 0; } .printable{border:2px; border-color:red;}}</style>');
    printWindow.document.write('</head><body>');
    printWindow.document.write(`<div class="printable">${printContents}</div>`);
    printWindow.document.write('</body></html>');
    printWindow.document.close();
    printWindow.print();
  };
  //============================ print functionality end ====================================




  //---------- search functionality start --------------
  const [searchParagraph, setsearchParagraph] = useState("")
  const [searchLexile, setsearchLexile] = useState("")
  const [filteredData, setfilteredData] = useState(paragraphName)


  useEffect(() => {
    // const handler = setTimeout(() => {
    //   if (searchLexile === "") {
    //     setfilteredData(paragraphName)
    //   } else {
    //     const filtered = paragraphName.filter((data) =>
    //       data.lexile_score.toLowerCase().includes(searchLexile.toLowerCase())
    //     )
    //     setfilteredData(filtered)
    //   }
    const handler = setTimeout(() => {
      if (searchLexile === "") {
        setfilteredData(paragraphName);
      } else {
        // Check if the search input contains a range
        const rangeMatch = searchLexile.match(/^(\d+)-(\d+)$/);
        if (rangeMatch) {
          const [min, max] = rangeMatch.slice(1).map(Number);
          const filtered = paragraphName.filter(data => {
            const lexileScore = parseInt(data.lexile_score, 10);
            return lexileScore >= min && lexileScore <= max;
          });
          setfilteredData(filtered);
        } else {
          const filtered = paragraphName.filter(data =>
            data.lexile_score.toLowerCase().includes(searchLexile.toLowerCase())
          );
          setfilteredData(filtered);
        }
      }
    }, 500);

    // cleanup timeout if searchLexile changes before delay is over 
    return () => {
      clearTimeout(handler)
    }

  }, [searchLexile, paragraphName])




  //---------- search functionality end --------------

  //==================== maintains logs start ===============================
  // useEffect(() => {
  //   const logParagraphDelete = async () => {
  //     try {
  //       await axios.post(`${API}/logs`, {
  //         action: 'Delete',
  //         resource: 'paragraph',
  //         resourceId: deleteParagraphlogid._id,
  //         details: { paragraph_name: deleteParagraphlogid.paragraph_name },
  //       });
  //     } catch (error) {
  //       console.error('Error logging view:', error);
  //     }
  //   };
  //   logParagraphDelete();
  // }, [deleteParagraphlogid]);
  //==================== maintains logs end ===============================


  return (
    <div>
      <div className=''>
        <Header />
        {/* paragraphs added over here start  */}
        <div className='mt-[70px] sm:my-[150px] mx-[20px]'>
          {/* show rubric start  */}

          {/* show rubric end  */}
          <div className='sticky top-[67px] sm:top-[138px] bg-white  py-[10px] px-[10px] sm:px-[20px] w-full '>
            <div className='flex justify-between items-center'>
              <div>
                <h2 className='text-[15px] sm:text-[30px] font-medium text-[#374CC3]'>Paragraph</h2>
                <p className='text-[10px] sm:text-[18px] font-medium text-[#374CC3]'>Total Paragraphs:{TotalparagraphName}</p>
              </div>
              <div>
                <p onClick={() => setShowRubric(true)} className='text-[10px] sm:text-[20px] font-medium text-[#374CC3] cursor-pointer'>Show Rubric</p>
              </div>
            </div>


            <div className='flex gap-4 items-center ' >
              <div className='w-[45%] sm:w-[25%]'>
                <div >
                  <h2 className='text-[12px] sm:text-[15px]'>Search Paragraph:</h2>
                  <select value={searchParagraph} onChange={(e) => setsearchParagraph(e.target.value)} className='text-[12px] sm:text-[15px] bg-black outline-none w-full text-white'>
                    <option value="">Select Your Paragraph</option>
                    {
                      paragraphName && paragraphName.map((item, index) => {
                        return (
                          <option key={index} value={item.paragraph_name}>{item.paragraph_name}</option>
                        )
                      })

                    }
                  </select>
                </div>
              </div>

              <div className='w-[45%] sm:w-[25%]'>
                <div>
                  <h2 className='text-[12px] sm:text-[15px]'>Search Lexile:</h2>

                </div>
                <input value={searchLexile} onChange={(e) => setsearchLexile(e.target.value)} type="search" className='bg-black outline-none w-full text-white px-[10px] text-[12px] sm:text-[15px]' placeholder='Search Lexile here' />
              </div>

            </div>

          </div>
          <div>
            {
              filteredData && filteredData.filter((item) => {
                if (searchParagraph === "") {
                  return item
                } else {
                  return item.paragraph_name === searchParagraph
                }
              }).map((item, index) => {
                return (
                  <div id={`printable-${index}`} ref={printRef} key={index} className='border-[1px] border-black border-collapse my-[5px]'>
                    <div className=' w-[100%]  mt-[10px]'>
                      <div className='flex justify-between items-center'>
                        <h1 className='text-[12px] sm:text-[20px] font-bold'>{item.paragraph_name}</h1>
                        <div className='pr-[20px]'>
                          <button onClick={() => handlePrint(index)} className='px-[13px] py-[4px] sm:px-[26px] sm:py-[8px] text-[10px] sm:text-[15px]  bg-black text-white rounded-md'>Print</button>
                        </div>
                      </div>
                      <div className='flex gap-10'>
                        <div>
                          <h2 className='text-[12px] sm:text-[15px] font-bold'>Students Age:- <span className='font-thin'>{item.student_age.join(", ")}</span></h2>
                        </div>
                        <div>
                          <h2 className='text-[12px] sm:text-[15px] font-bold'>Grade Level:- <span className='font-thin'>{item.student_grade.join(", ")}</span></h2>
                        </div>
                      </div>
                      <div className='flex gap-10'>
                        <div>
                          <h2 className='text-[12px] sm:text-[15px] font-bold'>Lexile Score:- <span className='font-thin'>{item.lexile_score}L</span></h2>
                        </div>
                        <div>
                          <h2 className='text-[12px] sm:text-[15px] font-bold ' >Approx Word:- <span className='font-thin'>{item.approx_word_count}</span></h2>
                        </div>
                        <div>
                          <h2 className='text-[12px] sm:text-[15px] font-bold ' >Paragraph Type:- <span className='font-thin'>{item.paragraphType}</span></h2>
                        </div>
                      </div>
                      <div className='w-[100%] sm:w-[80%] border-[1px] p-[3px] sm:p-[10px] text-[12px] sm:text-[15px]'>
                        {/* remove start from the paragraphs  */}
                        {item.paragraph_details.split("*")}
                      </div>

                      {
                        loggedinRole && loggedinRole === "Super Admin" ? (

                          <div className='flex gap-5 ml-[10px] my-[10px]'>
                            <button onClick={() => HandleEdit(item._id)} className='px-[13px] py-[4px] sm:px-[26px] sm:py-[8px] bg-[#6c7ae0] text-white rounded-md text-[12px] sm:text-[15px]'>Edit</button>
                            <button onClick={() => HandleDeletePopUp(item._id)} className='px-[13px] py-[4px] sm:px-[26px] sm:py-[8px] bg-[#6c7ae0] text-white rounded-md text-[12px] sm:text-[15px]' >Delete</button>

                          </div>
                        ) : null
                      }

                    </div>
                  </div>
                )
              })
            }
          </div>
        </div>
        {/* paragraphs added over here end */}


        {/* =========================edit paragraph start  =======================================*/}
        {
          EditParagraphModal && EditParagraphModal ? (
            <div>
              <div className='inset-0 flex justify-center items-center fixed z-[50] bg-[#1c1d1f]/30' >
                <div className='w-[80%]'>

                  <div className='max-w-[1500px] w-full bg-white ]' >
                    {/* paragraph, lexile score, approx word count start  */}



                    <div className='bg-[#6C7AE0] text-white flex justify-between items-center px-[10px]'>
                      <div> <h1 className='text-[30px] '>Update Paragraph</h1></div>
                      <div ><MdClose onClick={() => setsetEditParagraphModal(false)} size={35} /></div>
                    </div>
                    <div className=' p-[10px]'>
                      <div className=' my-[10px] lg:my-[20px] flex justify-between p-[20px'>
                        <div className='w-[40%]'>
                          <div className=''>
                            <label className='text-[15px] xl:text-[18px] ' htmlFor="">Enter Paragraph Name:</label>
                          </div>
                          <div className='w-[100%] xl:w-[80%]' >
                            <input value={editparagraph_name} onChange={(e) => seteditparagraph_name(e.target.value)} className='w-full bg-black/80 text-white py-[8px]  xl:py-[8px]  xl:py-[10px] px-[10px] outline-none rounded-md' type="text" placeholder='Enter Paragraph Name' />
                          </div>
                        </div>

                        <div className='w-[45%] sm:w-[18%]'>
                          <div className=''>
                            <label className='text-[12px] sm:text-[18px] ' htmlFor="">Paragraph Type:</label>
                          </div>
                          <div className='w-[100%]' >
                            <select value={editparagraphType} onChange={(e) => seteditparagraphType(e.target.value)} className='text-[12px] sm:text-[15px] w-full bg-black/80 text-white py-[10px] px-[10px] outline-none rounded-md' >
                              <option value="">select Paragraph type</option>
                              <option value="FICTION">FICTION</option>
                              <option value="NON-FICTION">NON-FICTION</option>
                              <option value="GENERAL">GENERAL</option>
                            </select>
                          </div>
                        </div>
                        <div className='w-[20%] xl:w-[18%]'>
                          <div className=''>
                            <label className='text-[15px] xl:text-[18px] ' htmlFor="">Enter Lexile Score:</label>
                          </div>
                          <div className='w-[100%]' >
                            <input value={editlexile_score} onChange={(e) => seteditlexile_score(e.target.value)} className='w-full bg-black/80 text-white py-[8px]  xl:py-[10px] px-[10px] outline-none rounded-md' type="number" placeholder='Enter Lexile Score' />
                          </div>
                        </div>
                        <div className='w-[25%] xl:w-[18%]'>
                          <div className=''>
                            <label className='text-[15px] xl:text-[15px]  ' htmlFor="">Enter Approx word Count:</label>
                          </div>
                          <div className='w-[100%]'>
                            <input value={editapprox_word_count} onChange={(e) => seteditapprox_word_count(e.target.value)} className='w-full bg-black/80 text-white py-[8px]  xl:py-[10px] px-[10px] outline-none rounded-md' type="text" placeholder='Enter Approx word Count' />
                          </div>
                        </div>
                      </div>
                      <div className=' my-[10px] lg:my-[20px] w-[50%] flex justify-between'>

                        <div className='w-[50%]'>
                          <div className=''>
                            <label className='text-[15px] xl:text-[18px] ' htmlFor="">Enter Student Age:</label>
                          </div>
                          {/* <input value={student_age} onChange={(e) => setstudent_age(e.target.value)} className='w-full bg-black/80 text-white py-[8px]  xl:py-[10px] px-[10px] outline-none rounded-md' type="text" placeholder='Enter Student Age' /> */}
                          <div className='w-[90%]' >

                            {/* <select value={editstudent_age} onChange={(e) => seteditstudent_age(e.target.value)} className='w-full bg-black/80 text-white py-[8px]  xl:py-[10px] px-[10px] outline-none rounded-md'>
                              <option value="">Select student age</option>
                              {
                                getAllStudetnAge && getAllStudetnAge.map((item, index) => {
                                  return (
                                    <option key={index} value={item.name}>{item.name}</option>
                                  )
                                })
                              }

                            </select> */}


                            <Select
                              labelId="demo-multiple-checkbox-label"
                              id="demo-multiple-checkbox"
                              style={{ color: "white" }}
                              className='rounded-md bg-black  w-full outline-none MuiSelect-select  '
                              multiple
                              value={editstudent_age}
                              onChange={handleChange}
                              placeholder='Select Section'
                              // onChange={handleSearchSection}
                              // input={<OutlinedInput  label="Select Section" />}
                              renderValue={(selected) => selected.join(',')}
                            // MenuProps={MenuProps}
                            >
                              {getAllStudetnAge && getAllStudetnAge.map((name, index) => (

                                <MenuItem selected className="MenuItem" key={name._id} value={name.name}>
                                  <Checkbox checked={editstudent_age.indexOf(name.name) > -1} />
                                  <ListItemText primary={name.name} />
                                </MenuItem>

                              ))}
                            </Select>

                          </div>
                        </div>
                        <div className='w-[50%]'>
                          <div className=''>
                            <label className='text-[15px] xl:text-[18px] ' htmlFor="">Enter Student Grade:</label>
                          </div>
                          <div className='w-[90%]' >
                            {/* <input value={student_grade} onChange={(e) => setstudent_grade(e.target.value)} className='w-full bg-black/80 text-white py-[8px]  xl:py-[10px] px-[10px] outline-none rounded-md' type="text" placeholder='Enter Student Grade' /> */}
                            {/* <select value={editstudent_grade} onChange={(e) => seteditstudent_grade(e.target.value)} className='w-full bg-black/80 text-white py-[8px]  xl:py-[10px] px-[10px] outline-none rounded-md'>
                              <option value="">Select student Grade</option>
                              {
                                allClassDATA && allClassDATA.map((item, index) => {
                                  return (
                                    <option key={index} value={item.name}>{item.name}</option>
                                  )
                                })
                              }

                            </select> */}

                            <Select
                              labelId="demo-multiple-checkbox-label"
                              id="demo-multiple-checkbox"
                              style={{ color: "white" }}
                              className='rounded-md bg-black  w-full outline-none MuiSelect-select  '
                              multiple
                              value={editstudent_grade}
                              onChange={handleChangeGrade}
                              placeholder='Select Section'
                              // onChange={handleSearchSection}
                              // input={<OutlinedInput  label="Select Section" />}
                              renderValue={(selected) => selected.join(',')}
                            // MenuProps={MenuProps}
                            >
                              {allClassDATA && allClassDATA.map((name, index) => (

                                <MenuItem selected className="MenuItem" key={name._id} value={name.name}>
                                  <Checkbox checked={editstudent_grade.indexOf(name.name) > -1} />
                                  <ListItemText primary={name.name} />
                                </MenuItem>

                              ))}
                            </Select>
                          </div>
                        </div>


                      </div>
                      {/* paragraph, lexile score, approx word count end  */}

                      {/* Enter paragraph start  */}
                      <div>
                        <textarea value={editparagraph_details} onChange={(e) => seteditparagraph_details(e.target.value)} className=' md:h-[200px]  w-full bg-black/80 text-white outline-none px-[10px] py-[8px] resize-none' rows={13} placeholder='Enter Your Paragraph Here...' >

                        </textarea>
                      </div>
                      {/* Enter paragraph end */}

                      {/* Add details button start  */}
                      <div className='flex justify-center items-center mt-[10px] rounded-md'>
                        <button onClick={() => handleEditParagraph(selectedParagraphId)} className='bg-[#1B1B1B] hover:bg-[#8321A8] px-[20px] py-[5px] text-white font-semibold rounded-md'>Update</button>
                      </div>
                      {/* Add details button end */}
                    </div>

                  </div>
                </div>
              </div>
            </div>
          ) : null

        }
        {/* =========================edit paragraph end  =======================================*/}


        {/* ==============================delete paragraph start==============================  */}
        {
          deleteParagraph && deleteParagraph ? (
            <div className='inset-0 flex justify-center items-center fixed z-[50] bg-[#1c1d1f]/30' >
              <div className='w-[300px] bg-black rounded-md py-[20px]'>
                <div>
                  <h4 className='text-[12px] text-white font-semibold text-center'>Deleting this paragraph might also delete the questions related to this Paragraph, would you like to delete?</h4>
                </div>



                <div className='flex gap-6 justify-center my-[10px]'>
                  {/* <button onClick={editCalculateUtilization} className='bg-[#1a5800] px-[15px] py-[5px] text-white rounded-md' >Calculate Total Utilization</button> */}
                  <button onClick={() => handleDeleteParagraph(deleteParagraphid)} className='bg-[#ec4848] px-[15px] py-[5px] text-white rounded-md' >Delete</button>
                  <button onClick={() => setdeleteParagraph(false)} className='bg-[#1a5800] px-[15px] py-[5px] text-white rounded-md' >Cancel</button>
                </div>
              </div>
              {/* input field block end */}
            </div>
          ) : null
        }
        {/* ==============================delete paragraph end==============================  */}



        {/* ===================rubric image start============================  */}
        {
          showRubric && showRubric ? (
            <div>
              <div className='fixed inset-0 flex justify-center items-center bg-black/70'>
                <div className=' w-[70%] bg-white'>
                  <div className='bg-[#8321A8] text-white flex justify-between items-center px-[10px]'>
                    <div> <h1 className='text-[30px] '>Rubric </h1></div>
                    <div ><MdClose onClick={() => setShowRubric(false)} size={35} /></div>
                  </div>
                  <div>
                    <div className='flex justify-center items-center'>
                      <img src={Lexile_rubric} alt="Lexile rubric image" />

                    </div>
                  </div>

                </div>

              </div>
            </div>
          ) : null
        }

        {/* ===================rubric image end============================  */}

      </div>
    </div>
  )
}

export default View